import api from './api.service'

export const BASE_PATH_CRUD_DINAMICO = '/lottustech/crud-dinamico'

export function getDefinicao(chave) {
  return api.get(`${BASE_PATH_CRUD_DINAMICO}/definicao/${chave}`)
}

export function pathRegistros(chave) {
  return `${BASE_PATH_CRUD_DINAMICO}/${chave}`
}
